import { HttpHeaders } from "@angular/common/http";

export const utility = {
    allHeader: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
    }),
    jsonHeader: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/json'
    }),

    pdfHeader: new HttpHeaders({
        'Content-Type': 'application/pdf',
        'Accept': '*/*'
    }),
    xmlHeader: new HttpHeaders({
        'Content-Type': 'application/xml',
        'Accept': 'text/XML'
    }),
    textHeader: new HttpHeaders({
        'Content-Type': 'application/text',
        'Accept': 'text/plain'
    }),
    fileUploadHeader: new HttpHeaders({
        'Accept': '*/*'
    })

    // { headers: headers, responseType: 'blob' }

}

export function PrintElem(elem){
    let mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title>' + document.title  + '</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write('<h1>' + document.title  + '</h1>');
    mywindow.document.write(document.getElementById(elem).innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
}
